"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionStepDefinition = void 0;
const WidgetStepPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPlugin");
const TemplateTypes_1 = require("../../../../Enum/TemplateTypes");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
const InchcapeBaseEvents_1 = require("../../../../Enum/InchcapeBaseEvents");
const StepEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/StepEvents");
const WidgetStepPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPluginDefinition");
class ExceptionStep extends WidgetStepPlugin_1.default {
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.EXCEPTION_STEP).getTemplate();
    }
    /**
     * @inheritDoc
     */
    initialize() {
        return super.initialize().then(() => {
            const valuation = this.state.getValuation();
            if (valuation.getContextMessage()) {
                this.state.setExceptionContextMessage(valuation.getContextMessage());
            }
        });
    }
    /**
     * @inheritDoc
     */
    render() {
        const result = super.render();
        this.renderer.set("submit", this.submit.bind(this));
        return result;
    }
    /**
     * @inheritDoc
     */
    submit(target) {
        const valuation = this.state.getValuation();
        this.eventContext.emit(StepEvents_1.StepEvents.STEP_FINISHED);
        this.eventContext.emit(InchcapeBaseEvents_1.InchcapeBaseEvents.CLOSE, valuation);
        this.eventContext.emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.CLOSE_EXCEPTION);
    }
}
exports.default = ExceptionStep;
exports.ExceptionStepDefinition = new WidgetStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.EXCEPTION,
    progressIndex: 6,
    class: ExceptionStep,
    linear: false,
});
